import { render, staticRenderFns } from "./proposal-31-pricing-option.vue?vue&type=template&id=1d8af8c0"
import script from "./proposal-31-pricing-option.vue?vue&type=script&lang=js"
export * from "./proposal-31-pricing-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports